import type { ShadeRoomColor } from "./types";

// Shades run from 28% darker to 28% lighter than the zone colour.
const MAX_SHADE_SHIFT = 0.28;

// Lighten towards white for a positive shift, darken towards black for a negative one.
const shadeChannel = (channel: number, shift: number): number =>
  Math.round(
    shift >= 0 ? channel + (255 - channel) * shift : channel * (1 + shift),
  );

// Spreads the rooms of a zone evenly from darkest to lightest by their position in it.
export const shadeRoomColor: ShadeRoomColor = ({
  rgb: [red, green, blue],
  position,
  count,
}) => {
  const shift =
    count > 1 ? MAX_SHADE_SHIFT * ((2 * position) / (count - 1) - 1) : 0;
  return [
    shadeChannel(red, shift),
    shadeChannel(green, shift),
    shadeChannel(blue, shift),
  ];
};
